import { apiRoutes } from '@features/campaigns/details/consts/apiRoutes.ts';
import { CampaignDetails } from '@features/campaigns/shared/types/campaign.ts';
import { BillingDetailsPayload } from '@features/campaigns/shared/types/campaignDetails.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { CampaignId } from '@shared/types/campaign.ts';

export async function updateBillingDetails(
  payload: BillingDetailsPayload,
  campaignId: CampaignId,
): Promise<CampaignDetails | null> {
  return await apiClient.patch<BillingDetailsPayload, CampaignDetails>(
    apiRoutes.updateBillingDetails(campaignId),
    payload,
  );
}
